<div class="filters">
    <div class="filters-controls">
        <app-report-main-filters-form></app-report-main-filters-form>
        <div class="additional-filters">
            <app-report-additional-filters-form></app-report-additional-filters-form>
            @if (currentTab() === 'Grid View' && allowGrouping()) {
                <app-group-by-rows-filter [cols]="gridSettings()"></app-group-by-rows-filter>
            }
            @if (currentTab() === 'Grid View') {
                <app-column-visibility-filter></app-column-visibility-filter>
            }
        </div>
        @if (isLoading()) {
            <div class="filters-lock" aria-hidden="true"></div>
        }
    </div>
    <button class="btn primary-btn runButton" (click)="onRun()" tabindex="0" [disabled]="isLoading()">Run</button>
</div>
